module.exports = __webpack_public_path__ + "media/escudos/logo_gr_amazonas-24431f84.png";